import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HomeViewInternal from '../views/HomeViewCopy.vue'

const routes = [
  {
    path: '/index',
    name: 'homeIntarnal',
    component: HomeView,
    meta: { keepAlive: true }
  },
  { path: '/', name: 'home', component: HomeViewInternal },
  {
    path: '/previewblobform/:ids',
    name: 'previewblobform',
    component: () => import('@/views/previewblobform.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/directional/:id/:title',
    name: 'directional',
    component: () => import('@/views/directionalView.vue')
  },
  
  // {
  //   path: '/news/:id/:title',
  //   name: 'news',
  //   component: () => import('@/views/newsView.vue')
  // },
  {
    path: '/newsData/:id/:title/:ids',
    name: 'newsData',
    component: () => import('@/views/newsDataView.vue')
  },
  {
    path: '/newsDataViewAfter/:id/:title/:ids',
    name: 'newsDataViewAfter',
    component: () => import('@/views/newsDataViewAfter.vue')
  },
  
  // 新闻封面
  {
    path: '/newsCover/:id/:title',
    name: 'newsCover',
    component: () => import('@/views/newsCoverView.vue')
  },
  
  {
    path: '/previewblobformCheck/:id',
    name: 'previewblobformCheck',
    component: () => import('@/views/previewblobformCheck.vue')
  },
  // 关于我们
  {
    path: '/about/:id/:title',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  },
  // 号码状态检测
  {
    path: '/gateway',
    name: 'gateway',
    component: () => import('@/views/gatewayView.vue')
  },
  // 短信群发
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/productView.vue')
  },
  // 5g消息
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/messageView.vue')
  },
  // 彩信群发
  {
    path: '/discuss',
    name: 'discuss',
    component: () => import('@/views/discussView.vue')
  },
  {
    path: '/detection',
    name: 'detection',
    component: () => import('@/views/detectionView.vue')
  },
  {
    path: '/productCenter/:id/:title',
    name: 'productCenter',
    component: () => import('@/views/productCenterView.vue')
  },
  // 语音外呼
  {
    path: '/voiceCall',
    name: 'voiceCall',
    component: () => import('@/views/voiceCallView.vue')
  },
  // 智能营销
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import('@/views/marketingView.vue')
  },
  // 合作案例
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import('@/views/cooperateView.vue')
  },
  // 资讯
  {
    path: '/news/:id/:title',
    name: 'news',
    component: () => import('@/views/informationView.vue')
  },
  // 留言板
  {
    path: '/messageBoard',
    name: 'messageBoard',
    component: () => import('@/views/messageBoardView.vue')
  },
    // 国内短信
    {
      path: '/domesticSMS',
      name: 'domesticSMS',
      component: () => import('@/views/domesticSMSView.vue')
    },
      // 国际短信
      {
        path: '/internationalSMS',
        name: 'internationalSMS',
        component: () => import('@/views/internationalSMSView.vue')
      },
      // 国际关于我们
      {
        path: '/internationalAbout',
        name: 'internationalAbout',
        component: () => import('@/views/internationalAboutView.vue')
      },
      // 国际信任中心
      {
        path: '/internationalTrust',
        name: 'internationalTrust',
        component: () => import('@/views/internationalTrustView.vue')
      }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  if (from.path !== to.path) {
    // 如果不是同一个页面，则跳转后自动滚动到顶部
    next(() => {
      window.scrollTo(0, 0);
    });
  } else {
    next();
  }
})
export default router
